'use client'

import { useState } from 'react'

import { fraunces } from '@/fonts/fraunces'
import { useTranslation } from '@/hooks/client'
import { tw } from '@/lib/utils'

import { ContactBackdrops } from './backdrops'
import { EditorialColumn } from './editorial-column'
import { FormCard } from './form-card'
import { SuccessPanel } from './success-panel'

export interface ContactFormClientProps {
  editableProps?: Record<string, unknown>
}

export const ContactFormClient = ({ editableProps }: ContactFormClientProps) => {
  const { t } = useTranslation()
  const [submitMessage, setSubmitMessage] = useState<string | null>(null)

  return (
    <section
      className={tw(
        // Fraunces is scoped HERE (the lazily-imported contact-form client)
        // instead of the global layout, so its render-blocking @font-face CSS
        // only ships on pages with the form. fraunces.variable sets
        // --font-fraunces for the inline `var(--font-fraunces)` styles below.
        fraunces.variable,
        'bg-cream relative isolate overflow-hidden',
        '-mx-6 md:-mx-12',
        'px-6 pt-10 pb-20 sm:px-8 md:px-12 md:pt-16 md:pb-28 lg:px-16'
      )}
      {...editableProps}
    >
      <ContactBackdrops />

      <div className="desktop-xl:max-w-[1440px] relative mx-auto w-full">
        <div className="grid w-full grid-cols-1 gap-12 lg:grid-cols-[1.05fr_1fr] lg:gap-16 xl:gap-24">
          <EditorialColumn />

          <div className="relative">
            <div className="text-navy/45 mb-4 font-mono text-[11px] tracking-[0.32em] uppercase md:text-right">
              {'02 / '}
              {t('contact.eyebrowSendNote', 'Send a note')}
            </div>

            {submitMessage === null ? (
              <FormCard onSuccess={setSubmitMessage} />
            ) : (
              <SuccessPanel message={submitMessage} />
            )}
          </div>
        </div>
      </div>
    </section>
  )
}
